import Swal from 'sweetalert2'

const CloudError = {
    error: (error) => {
      if(error.response){
        const apiMessage = error.response.data?.message;
        switch (error.response.status) {
            case 422:
            if (apiMessage && !error.response.data?.errors) {
              Swal.fire({
                title: "Boleto no válido",
                text: apiMessage,
                icon: 'error',
              });
              break;
            }
            let errors = Object.keys(error.response.data.errors || {});
            var footerText = "";
            Array.from(errors).forEach((err) => {
              const messages = error.response.data.errors[err];
              footerText += Array.isArray(messages) ? messages.join(' ') : messages;
            });
            Swal.fire({
              title: "Ups!",
              text: apiMessage || "Los datos enviados son invalidos",
              icon: 'error',
              footer: footerText
            });
          break;
          case 204:
            // Do nothing
            console.log("processing...");
          break;
          case 401:
            Swal.fire({
              title: "Ups!",
              text: "No cuenta con autorización para ingresar",
              icon: 'error',
            });
          break;
          case 403:
            Swal.fire({
              title: "Acceso denegado",
              text: apiMessage || "No tienes permiso para esta acción.",
              icon: 'error',
            });
          break;
          case 404:
            Swal.fire({
              title: "No encontrado",
              text: apiMessage || "Boleto no encontrado",
              icon: 'error',
            });
          break;
          case 409:
            Swal.fire({
              title: "Ya escaneado",
              text: apiMessage || "Este boleto ya fue sellado.",
              icon: 'warning',
            });
          break;
          default:
            Swal.fire({
              title: "Ups!",
              text: apiMessage || "Lo sentimos, algo salió mal",
              icon: 'error',
            });
            console.log(error);
          break;
        }
      }else{
        Swal.fire({
          title: "Ups!",
          text: "Lo sentimos, algo salió mal",
          icon: 'error',
        });
      }
    }
}

export default CloudError;